import AppHeader from '../AppHeader'

export default {
  name: 'master-tanomail-new',
  created () {
    this.getShop()
  },
  data () {
    return {
      canValidate: true,
      shop_id: '',
      represent_code: '2001500099',
      group_code: '',
      login_id: '',
      password: '',
      management_number: 'KANRIBU',
      receive_responsible: '荷受取担当者',
      shopId: '',
      shops: [],
      shopGetCallbackFlag: false,
      isSaving: false
    }
  },
  computed: {
    validation () {
      let validation = {
        shop_id: !!this.shopId,
        group_code: !!this.group_code,
        login_id: !!this.login_id,
        password: !!this.password
      }
      if (!this.canValidate) {
        Object.keys(validation).forEach(
          key => {
            validation[key] = true
          }
        )
      }
      return validation
    },
    validationAll () {
      if (!this.validation.shop_id) return false
      if (!this.validation.group_code) return false
      if (!this.validation.login_id) return false
      if (!this.validation.password) return false

      return true
    }
  },
  components: {
    AppHeader
  },
  methods: {
    async getShop () {
      this.shopGetCallbackFlag = false
      let data = {}
      let res = await this.$store.dispatch('GET_SHOP_TARGET_STOCK', data)
                                  .catch(err => {
                                    console.log(err)
                                    return
                                  })
      this.shops = res.data
      this.shopGetCallbackFlag = true
    },
    async onClickSave () {
      // 連打対応
      if (this.isSaving) return false
      this.isSaving = true

      // 保存処理
      await this.$store.dispatch('CREATE_MASTER_TANOMAIL', {
        data: {
          shop_id: this.shopId,
          represent_code: this.represent_code,
          group_code: this.group_code,
          login_id: this.login_id,
          password: this.password,
          management_number: this.management_number,
          receive_responsible: this.receive_responsible
        }
      })
      .catch(err => {
        console.error(err)
        return
      })

      // たのめーるアカウント一覧へ戻る
      this.$router.push('/master_tanomail_list')
    },
    onClickCancel () {
      this.$router.push('/master_tanomail_list')
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/master-tanomail-new.js